import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export class DateUtils {
  static getDOB(date: number, month: number, year: number): Date {
    return new Date(year, month - 1, date);
  }

  static calculateAge(dob: Date): number {
    const birthDate = dayjs(dob);
    const today = dayjs(new Date());
    return today.diff(birthDate, 'year');
  }

  static getLocaleDate(date?: Date | null) {
    date = date ?? new Date();
    return DateUtils.adjustForTimezone(date);
  }

  static adjustForTimezone(date: Date): Date {
    const timeOffsetInMS: number = -(date.getTimezoneOffset() * 60000);
    date.setTime(date.getTime() + timeOffsetInMS);

    return date;
  }

  static getDateString(date: Date, dayjsFormat = 'DD/MM/YYYY'): string {
    return dayjs(date).utc(true).format(dayjsFormat);
  }

  static getUTCDate(date?: Date | null): Date | null {
    if (date) {
      return dayjs(date).utc(true).toDate();
    }
    return null;
  }

  static getDaysBetweenDates(fromDate: Date, toDate: Date) {
    return dayjs(fromDate).diff(dayjs(toDate), 'day');
  }
}
